<template>
	<card-slot
			:icon="icon"
			:icon-height="iconHeight"
			:icon-width="iconWidth"
			:title="titleTable"
			:is-add-item="isCreate"
			@updateEvent="onAddInventory(flag)"
	>
		<main-table
				padding="0"
				:flag="flag"
				:headers="headers"
				:listItems="listItems"
				@updateClickButton="onClickButton($event, flag)"
				:is-hide-header="false"
				:items-per-page-amount="500"
				:pages="[ 10, 20, 50, 100, 200, 500, 'All' ]"
				:is-pagination="false"
		></main-table>
	</card-slot>
</template>

<script>

import CardSlot from "@/shared/CardSlot/CardSlot.vue";

export default {
	name: "EmployeesWrapTable",
	components: { CardSlot },
	props: {
		icon: String,
		iconWidth: String,
		iconHeight: String,
		titleTable: String,
		flag: String,
		headers: Array,
		listItems: Array,
		isCreate: {
			type: Boolean,
			default: true,
		},
	},
	methods: {
		onAddInventory(args) {
			this.$emit('updateAddItem', args);
		},
		onClickButton({ key, item }, nameComponent) {
			this.$emit('updateClickButton', { key, item, nameComponent });
		},
	}
};
</script>

<style scoped lang="scss"></style>
